import { connect } from 'react-redux'
import { setBet, setSideBet } from 'macguffin/redux/actions'
import { uiButtonPressed, setPopupScreen } from '../../redux/actions'
import { SET_BET, SET_SIDE_BET } from 'macguffin/redux/constants'
import { Component, Currency } from 'macguffin'
import { getBet, stopPropagation } from '../../utils'

/**
 * This is the bet page under settings.
 */


@connect(
  state => ({
    legalBets: state.session.legalBets,
    betAmount: state.session.betAmount,
    betLines: state.session.betLines || 1,
    sideGames: state.base.sideGames,
    currencySign: state.session.currencySign,
    forcedBet: state.session.forcedBet,
    playing: state.base.playing,
    autoPlay: state.autoPlay,
  }),
  { setBet, setSideBet, uiButtonPressed, setPopupScreen }
)
export default class Bet extends Component {
  constructor(props) {
    super(props)
    this.betGridRef = React.createRef()
    this.scrollTopButton = React.createRef()
    this.scrollBottomButton = React.createRef()
    this.gridBetHeight = 38
  }

  componentDidMount() {
    this.scrollBetIntoView()
    this.checkScrollButtons()
  }

  componentDidUpdate() {
    this.scrollBetIntoView()
    this.checkScrollButtons()
  }

  /**
   * Sets the bet to the provided value.
   * @param {number} bet - New bet value.
   */
  setBet = bet => () => {
    this.props.setBet(bet)
    this.props.uiButtonPressed(SET_BET)
  }

  /**
   * Sets the side bet to the provided value.
   * @param {number} betAmount - New bet value.
   * @param {string} sideGameName - name value.
   */
  setSideBet = (betAmount, sideGameName) => () => {
    this.props.setSideBet(betAmount, sideGameName)
    this.props.uiButtonPressed(SET_SIDE_BET)
  }

  /**
   * Renders a DOM element containing the available sidebet values as buttons.
   * @param {object} game - name value.
   * @param {object} props - current props.
   */
  renderSidegame(game, props) {
    const { legalBets, betAmount, sideGameName } = game
    const {
      currencySign,
      playing,
      forcedBet,
      autoPlay: { autoPlaying } = {}
    } = props

    const allDisabled = playing || forcedBet || autoPlaying
    return (
      (legalBets && legalBets.length > 0) &&
      <div className="content-block" id="sideGameBet" key={sideGameName} style={{ width: '100%', paddingBottom: '10vh' }}>
        <div className="divider" />
        <div className="infoHeader">
          <h1 className="submenu-header">{this.t(`settings.sidegame.${sideGameName}`)}</h1>
          <h3 className="title-currency">{currencySign}</h3>
        </div>
        <div className="divider" />

        <div className="bet-grid">
          <button
            className={betAmount <= 0 ? 'selected' : ''}
            key={'settings.sidegame.off'}
            disabled={betAmount <= 0 || allDisabled}
            onClick={this.setSideBet(0, sideGameName)}
          >
            {this.t('settings.sidegame.off')}
          </button>

          {legalBets.map(sideBet => (
            <button
              className={sideBet === betAmount ? 'selected' : ''}
              key={sideBet}
              disabled={sideBet === betAmount || allDisabled}
              onClick={this.setSideBet(sideBet, sideGameName)}
            >
              {Currency.format(sideBet, { showCurrency: false })}
            </button>
          ))}
        </div>
      </div>
    )
  }

  renderTotalBet() {
    const {
      currencySign,
      sideGames,
      betAmount,
    } = this.props

    return (
      <div className="content-block" style={{ width: '100%' }} id={'totalBet'}>
        <div className="infoHeader">
          <h1 className="submenu-header">{this.t('gameControl.totalbet')}</h1>
          <h3 className="title-currency">{currencySign}</h3>
          <h1 className="submenu-header">{Currency.format(getBet(sideGames, betAmount), { showCurrency: false })}</h1>
        </div>
      </div>
    )
  }

  getLegalBetIndex = () => {
    const { legalBets, betAmount, betLines } = this.props
    return legalBets.indexOf(betAmount / betLines)
  }

  selectBet = (bet, betLines) => () => {
    this.setBet(bet * betLines)()
    this.props.setPopupScreen(null)
  }

  scrollBetIntoView = () =>
    this.betGridRef.current.children[this.betIndex].scrollIntoView({ block: 'center' })

  checkScrollButtons = () => {
    const scrollTopReached = this.betGridRef.current && this.betGridRef.current.scrollTop === 0
    const scrollBottomReached = this.betGridRef.current && this.betGridRef.current.scrollTop >= this.gridBetHeight * (this.props.legalBets.length - 5)

    this.scrollTopButton.current.className = `scroll-top ${scrollTopReached ? 'disabled' : ''}`
    this.scrollTopButton.current.children[0].className = `arrow-up ${scrollTopReached ? 'disabled' : ''}`

    this.scrollBottomButton.current.className = `scroll-bottom ${scrollBottomReached ? 'disabled' : ''}`
    this.scrollBottomButton.current.children[0].className = `arrow-down ${scrollBottomReached ? 'disabled' : ''}`
  }

  scrollUp = () =>
    this.betGridRef.current.scrollTop = Math.max(0, Math.round((this.betGridRef.current.scrollTop - this.gridBetHeight) / this.gridBetHeight) * this.gridBetHeight)

  scrollDown = () =>
    this.betGridRef.current.scrollTop = Math.round((this.betGridRef.current.scrollTop + this.gridBetHeight) / this.gridBetHeight) * this.gridBetHeight

  /**
   * Renders a DOM element containing the available bet values as buttons.
   * @returns {*}
   */
  render() {
    const { props } = this
    const {
      legalBets,
      betAmount,
      betLines,
      sideGames = [],
      playing,
      forcedBet,
      autoPlay: { autoPlaying } = {},
      formatStyle,
    } = props

    this.betIndex = [...legalBets].reverse().indexOf(betAmount / betLines)
    const getFormattedBet = bet => Currency.format(bet, formatStyle)
    const betMaxWidth = Math.max(...legalBets.map(bet => getFormattedBet(bet * betLines).length))
    const allDisabled = playing || forcedBet || autoPlaying

    return (
      <div className="content-block" onClick={stopPropagation} >
        {sideGames.length > 0 && this.renderTotalBet()}
        <button
          className="scroll-top"
          onClick={this.scrollUp}
          ref={this.scrollTopButton}
        >
          <div className="arrow-up" />
        </button>
        <div className="main-content-block" style={{ width: 30 + betMaxWidth * 11 }} id="mainGameBet">
          <div className="bet-grid" ref={this.betGridRef} onScroll={this.checkScrollButtons} >
            {[...legalBets].reverse().map(bet => (
              <button
                className={bet === betAmount / betLines ? 'selected' : ''}
                key={bet}
                disabled={bet === betAmount / betLines || allDisabled}
                onClick={this.selectBet(bet, betLines)}
                style={{ height: `${this.gridBetHeight}px`, minHeight: `${this.gridBetHeight}px` }}
              >
                {getFormattedBet(bet * betLines)}
              </button>
            ))}
          </div>
        </div>
        <button
          className="scroll-bottom"
          onClick={this.scrollDown}
          ref={this.scrollBottomButton}
        >
          <div className="arrow-down" />
        </button>
        {sideGames.map(game => (
          this.renderSidegame(game, props)
        ))}
      </div>
    )
  }
}
